import type { FC } from 'react';
import { useParams } from 'react-router';
import { useMemoOne } from 'use-memo-one';
import type {
  DocumentExchangeResponse,
  DocumentsParams,
} from 'src/apis/document-exchange/types';
import { useOperatorDocumentsOutbox } from 'src/apis/document-exchange/use-operator-documents-outbox';
import { PageSpinner } from 'src/components/spinner-container';
import { useTitle } from 'src/hooks/use-title';
import { DocumentsFilterCard } from 'src/pages/shippers/documents/components/filter-card';
import { DocumentsTable } from 'src/pages/shippers/documents/table';
import { usePageParams } from 'src/pages/shippers/documents/use-page-params';

type Props = {
  documentExchange: DocumentExchangeResponse;
};

export const ToShipperPage: FC<Props> = ({ documentExchange }) => {
  useTitle('Document Overview');
  const pageParams = usePageParams();
  const { shipperUuid } = useParams<{ shipperUuid: string }>();

  const params = useMemoOne<DocumentsParams>(() => {
    const { start, pageSize, ...rest } = pageParams.value;
    return {
      offset: start,
      limit: pageSize,
      shipperId: shipperUuid,
      ...rest,
    };
  }, [pageParams.value]);

  const documents = useOperatorDocumentsOutbox({
    url: documentExchange._links.getOperatorDocumentsOutbox!.href, // checked in index.tsx
    params,
  });

  if (!documents.response) {
    return <PageSpinner />;
  }

  return (
    <div className="grid items-center gap-2xl">
      <DocumentsFilterCard
        type="OUTBOX"
        pageParams={pageParams}
        documents={documents}
      />

      <DocumentsTable
        type="OUTBOX"
        pageParams={pageParams}
        pending={documents.pending}
        documents={documents.response.data}
        showTableActions={false}
      />
    </div>
  );
};
